import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { FilterMatchMode } from 'primereact/api';
import { Dialog } from 'primereact/dialog';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import AddEditShiftMasterDialog from './AddEditShiftMaster';
import Toast from '../../Shared/Toast/Toast';
import DeleteConfirmation from '../../Dialogs/DeleteConfirmation';
import { InputSwitch } from 'primereact/inputswitch';
import { useCatchResponse } from '../../../utils/useCatchResponse';

const ShiftMaster = () => {
    const { catchResponse } = useCatchResponse();
    const [shiftList, setShiftList] = useState([]);
    const [masterData, setMasterData] = useState([]);
    const [shiftId, setShiftId] = useState('');
    const [visible, setVisible] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        ShiftName: { value: null, matchMode: FilterMatchMode.CONTAINS },
        ShiftStartTime: { value: null, matchMode: FilterMatchMode.CONTAINS },
        ShiftStartTime: { value: null, matchMode: FilterMatchMode.CONTAINS }
    });
    const [isDeleteConfirmation, setIsDeleteConfirmation] = useState(false);
    const [isStatusConfirmation, setIsStatusConfirmation] = useState(false);
    const [deleteId, setDeleteId] = useState('');
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [securityUserID, setSecurityUserID] = useState("");
    const [rows, setRows] = useState(10);
    const [first, setFirst] = useState(0);
    const [visibleStudentList, setVisibleStudentList] = useState(false);
    const [masterStudentList, setMasterStudentList] = useState([]);
    const [visibleClassList, setVisibleClassList] = useState(false);
    const [masterClassList, setMasterClassList] = useState([]);
    const [updatedStatus, setUpdatedStatus] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            try {
                Loader.show();
                const loginData = CommonConfig.loginData();
                setSecurityUserID(loginData?._id);
                await GetShiftList(loginData?._id);
            } catch (error) {
                Loader.hide();
                console.error('Error in useEffect:', error);
            } finally {
                Loader.hide();
            }
        };
        fetchData();
    }, []);

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['ShiftName'].value = value;
        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const onPageChange = (e) => {
        setFirst(e.first);
        setRows(e.rows);
    };

    const GetShiftList = async (id) => {
        try {
            let data = {
                UserID: id,
            }
            await api.post(APIConstant.path.getShiftList, data).then(async response => {
                let res = response;
                if (res.success) {
                    setShiftList(res.data);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            catchResponse(err);
        }
    }

    const UpdateShiftStatus = async () => {
        try {
            let data = {
                id: deleteId,
                Status: updatedStatus
            }
            await api.post(APIConstant.path.updateShiftDetailStatus, data).then(async response => {
                let res = response;
                if (res.success) {
                    Loader.hide();
                    Toast.success({ message: 'Shift status successfully' });
                    setDeleteId('');
                    setUpdatedStatus('');
                    GetShiftList(securityUserID);
                    setIsStatusConfirmation(false);
                }
            }).catch(err => {
                Loader.hide();
                setDeleteId('');
                setUpdatedStatus('');
                setIsStatusConfirmation(false);
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            setDeleteId('');
            setUpdatedStatus('');
            setIsStatusConfirmation(false);
            catchResponse(err);
        }
    }

    const DeleteShift = async () => {
        try {
            let data = {
                id: deleteId
            }
            await api.post(APIConstant.path.deleteShiftDetail, data).then(async response => {
                let res = response;
                if (res.success) {
                    Loader.hide();
                    Toast.success({ message: 'Shift deleted successfully' });
                    setDeleteId('');
                    GetShiftList(securityUserID);
                    setIsDeleteConfirmation(false);
                }
            }).catch(err => {
                Loader.hide();
                setIsDeleteConfirmation(false);
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            console.log(err);
            setIsDeleteConfirmation(false);
            catchResponse(err);
        }
    }

    const actionBodyTemplate = (rows) => {
        return (
            <React.Fragment>
                <div className='p-d-flex p-ai-center p-jc-end'>
                    <Button icon="pi pi-pencil" className="e-sction-btn p-m-1" onClick={() => {
                        setShiftId(rows._id)
                        setMasterData(rows);
                        setIsEdit(true)
                        setVisible(true)
                    }} />
                    <Button icon="pi pi-trash" className="e-sction-btn p-m-0" onClick={(e) => {
                        setIsDeleteConfirmation(true);
                        setDeleteId(rows._id);
                    }} />
                    <InputSwitch
                        checked={rows?.Status === 'Active' ? true : false}
                        onChange={(e) => {
                            toggleActiveStatus(rows._id, e.value);
                        }}
                        className="p-ml-2 p-mt-1"
                    />
                </div>
            </React.Fragment>
        );
    };

    const toggleActiveStatus = (id, status) => {
        setDeleteId(id);
        setUpdatedStatus(status === true ? 'Active' : 'Inactive');
        setIsStatusConfirmation(true);
    };

    const renderFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleClose}
            />
            <Button
                label="Delete"
                className="btn-text-action-primary"
                onClick={(e) => DeleteShift()}
            />
        </div>
    );

    const handleClose = () => {
        setIsDeleteConfirmation(false)
    };

    const renderStatusFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleCloseStatus}
            />
            <Button
                label="Save"
                className="btn-text-action-primary"
                onClick={(e) => UpdateShiftStatus()}
            />
        </div>
    );

    const handleCloseStatus = () => {
        setIsStatusConfirmation(false)
    };

    const onCancel = () => {
        setVisible(false);
        setShiftId('');
        setIsEdit(false);
        setMasterData([]);
        GetShiftList(securityUserID);
    }


    const actionBodyTemplateSrNo = (data, props) => {
        return props.rowIndex + 1;
    };

    const actionStartTemplate = (rowData, props) => {
        return formattedTime(rowData?.ShiftStart);
    };

    const actionEndTemplate = (rowData, props) => {
        return formattedTime(rowData?.ShiftEnd);
    };

    const formattedTime = (date) => {
        return new Date(date).toLocaleTimeString('en-US', {
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        })
    };

    return (
        <div className='wayment-owner-dashboard et-master-page'>
            <div className="heading-area p-d-flex p-ai-center p-jc-between">
                <div className="p-d-flex p-ai-baseline">
                    <i className="pi pi-refresh"></i>
                    <h2>Shift Master</h2>
                </div>
                <div className="p-d-flex p-ai-center p-jc-between">
                    <div className="searchbar-area e-searchbar-area">
                        <i className="pi pi-search" />
                        <InputText

                            value={globalFilterValue}
                            onChange={onGlobalFilterChange}
                            placeholder="Global Search"
                        />
                    </div>
                    <Button icon="pi pi-plus" className="e-h-btn" onClick={() => setVisible(true)} />
                </div>
            </div>
            <DataTable
                value={shiftList}
                paginator
                rows={rows}
                first={first}
                filters={filters}
                filterDisplay="menu"
                globalFilterFields={['ShiftName', 'ShiftStartTime', 'ShiftEndTime']}
                responsiveLayout="scroll"
                paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink JumpToPageInput"
                rowsPerPageOptions={[5, 10, 20]}
                currentPageReportTemplate="Showing {first}-{last} of {totalRecords} records"
                onPage={onPageChange}
                className='custom-table'
                scrollHeight='calc(100vh - 120px)'
                size='small'
            >
                <Column field="id" body={actionBodyTemplateSrNo} header="Sr No." style={{ width: '20%' }} />
                <Column
                    field="ShiftName"
                    header="Shift Name"
                    style={{ width: '30%' }}
                />
                <Column
                    field="ShiftStartTime"
                    header="Shift Start"
                    body={actionStartTemplate}
                    style={{ width: '30%' }}
                />
                <Column
                    field="ShiftEndTime"
                    header="Shift End"
                    body={actionEndTemplate}
                    style={{ width: '30%' }}
                />

                <Column body={actionBodyTemplate} header="Action" headerStyle={{ width: 'auto', textAlign: 'end' }} />
            </DataTable>
            <Dialog
                header={shiftId ? "Edit Shift Master" : "Add Shift Master"}
                className='dialog-popup'
                visible={visible}
                onHide={() => onCancel()}
                draggable={false}
                position="center"
                style={{ width: "40vw" }}
            >
                <AddEditShiftMasterDialog masterData={masterData} isEdit={isEdit} ID={shiftId} onCancel={onCancel} />

            </Dialog>
            <Dialog
                header="Teachers List"
                visible={visibleStudentList}
                onHide={() => {
                    setVisibleStudentList(false)
                    setMasterStudentList([]);
                }}
                draggable={false}
                position="center">

                <div className="p-col-12 p-card p-p-3">
                    <DataTable value={masterStudentList} paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink JumpToPageInput"
                        currentPageReportTemplate="Showing {first}-{last} of {totalRecords} records" rowsPerPageOptions={[10, 20, 50]} className='custom-table'
                        scrollHeight='calc(100vh - 120px)'
                        size='small'>
                        <Column body={actionBodyTemplateSrNo} header="Sr No." />
                        <Column field="Name" header="Teacher Name" />
                        <Column field="Email" header="Email" />
                        <Column field="Phone" header="Phone" />
                    </DataTable>
                </div>
            </Dialog>
            <Dialog
                header="Class List"
                visible={visibleClassList}
                onHide={() => {
                    setVisibleClassList(false)
                    setMasterClassList([]);
                }}
                draggable={false}
                position="center">

                <div className="p-col-12 p-card p-p-3">
                    <DataTable value={masterClassList} paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink JumpToPageInput"
                        currentPageReportTemplate="Showing {first}-{last} of {totalRecords} records" rowsPerPageOptions={[10, 20, 50]} className='custom-table'
                        scrollHeight='calc(100vh - 120px)'
                        size='small'>
                        <Column body={actionBodyTemplateSrNo} header="Sr No." />
                        <Column field="ClassName" header="Class Name" />
                        <Column field="Section" header="Section Name" />
                        <Column field="Board" header="Board Name" />
                        <Column field="Medium" header="Medium" />
                    </DataTable>
                </div>
            </Dialog>
            <Dialog
                visible={isDeleteConfirmation}
                onHide={handleClose}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Delete Confirmation</span>
                    </div>
                }
                footer={renderFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <DeleteConfirmation />
            </Dialog>
            <Dialog
                visible={isStatusConfirmation}
                onHide={handleCloseStatus}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Status Update</span>
                    </div>
                }
                footer={renderStatusFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <div>
                    <p>
                        Are you sure you want to update status?
                    </p>
                </div>
            </Dialog>
        </div>
    );
};

export default ShiftMaster;
